import { ChangeDetectionStrategy, Component, input } from '@angular/core'

type IconName = 'arrow-circle-right' | 'arrow-circle-up' | 'arrow-circle-down' | 'arrow-circle-left' | 'filter' | 'eye' | 'eye-off' | 'close' | 'search' | 'upload'

@Component({
  selector: 'icon-ui',
  host: { class: 'block' },
  template: `
    @switch (name()) {
      @case ('arrow-circle-right') {
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="100%"
          height="100%"
          viewBox="0 0 16 16"
          fill="none">
          <g clip-path="url(#clip0_109_25308)">
            <path
              d="M8 0C3.58947 0 0 3.58947 0 8C0 12.4105 3.58947 16 8 16C12.4105 16 16 12.4105 16 8C16 3.58947 12.4105 0 8 0ZM8 15.1579C4.05263 15.1579 0.842105 11.9474 0.842105 8C0.842105 4.05263 4.05263 0.842105 8 0.842105C11.9474 0.842105 15.1579 4.05263 15.1579 8C15.1579 11.9474 11.9474 15.1579 8 15.1579ZM9.98105 7.70316C10.1453 7.86737 10.1453 8.13474 9.98105 8.29895L7.45474 10.8253C7.37263 10.9074 7.26526 10.9495 7.15789 10.9495C7.05053 10.9495 6.94316 10.9074 6.86105 10.8253C6.69684 10.6611 6.69684 10.3937 6.86105 10.2295L9.09053 8L6.86105 5.77053C6.69684 5.60632 6.69684 5.33895 6.86105 5.17474C7.02526 5.01053 7.29263 5.01053 7.45684 5.17474L9.98316 7.70105L9.98105 7.70316Z"
              fill="currentColor" />
          </g>
          <defs>
            <clipPath id="clip0_109_25308">
              <rect
                width="16"
                height="16"
                fill="white" />
            </clipPath>
          </defs>
        </svg>
      }
      @case ('arrow-circle-up') {
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="100%"
          height="100%"
          viewBox="0 0 16 16"
          fill="none">
          <g clip-path="url(#clip1_109_25308)">
            <path
              d="M8 0C3.58947 0 0 3.58947 0 8C0 12.4105 3.58947 16 8 16C12.4105 16 16 12.4105 16 8C16 3.58947 12.4105 0 8 0ZM8 15.1579C4.05263 15.1579 0.842105 11.9474 0.842105 8C0.842105 4.05263 4.05263 0.842105 8 0.842105C11.9474 0.842105 15.1579 4.05263 15.1579 8C15.1579 11.9474 11.9474 15.1579 8 15.1579ZM8.29895 6.01895C8.13474 5.85474 7.86737 5.85474 7.70316 6.01895L5.17684 8.54526C5.09474 8.62737 5.05263 8.73474 5.05263 8.84211C5.05263 8.94947 5.09474 9.05684 5.17684 9.13895C5.34105 9.30316 5.60842 9.30316 5.77263 9.13895L8 6.90947L10.2295 9.13895C10.3937 9.30316 10.6611 9.30316 10.8253 9.13895C10.9895 8.97474 10.9895 8.70737 10.8253 8.54316L8.29895 6.01895Z"
              fill="currentColor" />
          </g>
          <defs>
            <clipPath id="clip1_109_25308">
              <rect
                width="16"
                height="16"
                fill="white" />
            </clipPath>
          </defs>
        </svg>
      }
      @case ('arrow-circle-down') {
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="100%"
          height="100%"
          viewBox="0 0 16 16"
          fill="none">
          <g clip-path="url(#clip2_109_25308)">
            <path
              d="M8 0C3.58947 0 0 3.58947 0 8C0 12.4105 3.58947 16 8 16C12.4105 16 16 12.4105 16 8C16 3.58947 12.4105 0 8 0ZM8 15.1579C4.05263 15.1579 0.842105 11.9474 0.842105 8C0.842105 4.05263 4.05263 0.842105 8 0.842105C11.9474 0.842105 15.1579 4.05263 15.1579 8C15.1579 11.9474 11.9474 15.1579 8 15.1579ZM7.70105 9.98105C7.86526 10.1453 8.13263 10.1453 8.29684 9.98105L10.8232 7.45474C10.9053 7.37263 10.9474 7.26526 10.9474 7.15789C10.9474 7.05053 10.9053 6.94316 10.8232 6.86105C10.6589 6.69684 10.3916 6.69684 10.2274 6.86105L8 9.09053L5.77053 6.86105C5.60632 6.69684 5.33895 6.69684 5.17474 6.86105C5.01053 7.02526 5.01053 7.29263 5.17474 7.45684L7.70105 9.98105Z"
              fill="currentColor" />
          </g>
          <defs>
            <clipPath id="clip2_109_25308">
              <rect
                width="16"
                height="16"
                fill="white" />
            </clipPath>
          </defs>
        </svg>
      }
      @case ('arrow-circle-left') {
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="100%"
          height="100%"
          viewBox="0 0 16 16"
          fill="none">
          <g clip-path="url(#clip3_109_25308)">
            <path
              d="M8 0C3.58947 0 0 3.58947 0 8C0 12.4105 3.58947 16 8 16C12.4105 16 16 12.4105 16 8C16 3.58947 12.4105 0 8 0ZM8 15.1579C4.05263 15.1579 0.842105 11.9474 0.842105 8C0.842105 4.05263 4.05263 0.842105 8 0.842105C11.9474 0.842105 15.1579 4.05263 15.1579 8C15.1579 11.9474 11.9474 15.1579 8 15.1579ZM6.01895 7.70316C6.18316 7.86737 6.18316 8.13474 6.01895 8.29895L8.54526 10.8253C8.62737 10.9074 8.73474 10.9495 8.84211 10.9495C8.94947 10.9495 9.05684 10.9074 9.13895 10.8253C9.30316 10.6611 9.30316 10.3937 9.13895 10.2295L6.90947 8L9.13895 5.77053C9.30316 5.60632 9.30316 5.33895 9.13895 5.17474C8.97474 5.01053 8.70737 5.01053 8.54316 5.17474L6.01895 7.70105L6.01895 7.70316Z"
              fill="currentColor" />
          </g>
          <defs>
            <clipPath id="clip3_109_25308">
              <rect
                width="16"
                height="16"
                fill="white" />
            </clipPath>
          </defs>
        </svg>
      }
      @case ('filter') {
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="100%"
          height="100%"
          viewBox="0 0 16 16"
          fill="none">
          <path
            d="M8 0C12.4105 0 16 3.58947 16 8C16 12.4105 12.4105 16 8 16C3.58947 16 0 12.4105 0 8C0 3.58947 3.58947 0 8 0ZM8 15.1579C11.9474 15.1579 15.1579 11.9474 15.1579 8C15.1579 4.05263 11.9474 0.842105 8 0.842105C4.05263 0.842105 0.842104 4.05263 0.842104 8C0.842104 11.9474 4.05263 15.1579 8 15.1579Z"
            fill="currentColor" />
          <path
            d="M11.2647 4H4.50196C3.92525 4 3.5 4.377944 3.5 4.84222V5.72023C3.5 5.88867 3.5778 6.04764 3.72086 6.1666L6.2909 8.32267C6.43271 8.44164 6.51177 8.60061 6.51177 8.76905V11.7895C6.51177 11.8695 6.56573 11.9421 6.65106 11.9779C6.6862 11.9926 6.7251 12 6.76275 12C6.81545 12 6.86941 11.9863 6.91333 11.9579L8.92118 10.6946C8.98392 10.6546 9.02157 10.5925 9.02157 10.5261V8.76905C9.02157 8.60061 9.09937 8.44164 9.24243 8.32267L11.8125 6.1666C11.9543 6.04764 12.0333 5.88867 12.0333 5.72023V4.84222C12.0333 4.37794 11.6082 4 11.2647 4ZM4.50196 4.42111H11.2647C11.5421 4.42111 11.7667 4.60955 11.7667 4.84222V5.68443H4.00196V4.84222C4.00196 4.60955 4.22659 4.42111 4.50196 4.42111ZM8.88729 8.02579C8.65012 8.22477 8.51961 8.48901 8.51961 8.7701V10.4219L7.01373 11.3694V8.7701C7.01373 8.48901 6.88322 8.22477 6.64604 8.02579L4.3571 6.10554H11.1762L8.88729 8.02579Z"
            fill="currentColor" />
        </svg>
      }
      @case ('eye') {
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 17 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M8.3601 8.82005C6.7001 8.82005 5.3501 7.47005 5.3501 5.81005C5.3501 4.15005 6.7001 2.80005 8.3601 2.80005C10.0201 2.80005 11.3701 4.15005 11.3701 5.81005C11.3701 7.47005 10.0201 8.82005 8.3601 8.82005ZM8.3601 3.79005C7.2501 3.79005 6.3501 4.69005 6.3501 5.80005C6.3501 6.91005 7.2501 7.81005 8.3601 7.81005C9.4701 7.81005 10.3701 6.91005 10.3701 5.80005C10.3701 4.69005 9.4701 3.79005 8.3601 3.79005Z"
            fill="currentColor" />
          <path
            d="M8.36012 11.4801C5.37012 11.4801 2.58012 9.56013 0.500117 6.06013C0.410117 5.90013 0.410117 5.71013 0.500117 5.55013C2.58012 2.06013 5.37012 0.130127 8.36012 0.130127C11.3501 0.130127 14.1401 2.05013 16.2201 5.55013C16.3101 5.71013 16.3101 5.90013 16.2201 6.06013C14.1401 9.55013 11.3501 11.4801 8.36012 11.4801ZM1.51012 5.80013C3.38012 8.82013 5.80012 10.4701 8.35012 10.4701C10.9001 10.4701 13.3201 8.81013 15.1901 5.80013C13.3201 2.78013 10.9001 1.13013 8.35012 1.13013C5.80012 1.13013 3.38012 2.79013 1.51012 5.80013Z"
            fill="currentColor" />
        </svg>
      }
      @case ('eye-off') {
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 17 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M8.80004 8.82005C7.14004 8.82005 5.79004 7.47005 5.79004 5.81005C5.79004 4.15005 7.14004 2.80005 8.80004 2.80005C10.46 2.80005 11.81 4.15005 11.81 5.81005C11.81 7.47005 10.46 8.82005 8.80004 8.82005ZM8.80004 3.79005C7.69004 3.79005 6.79004 4.69005 6.79004 5.80005C6.79004 6.91005 7.69004 7.81005 8.80004 7.81005C9.91004 7.81005 10.81 6.91005 10.81 5.80005C10.81 4.69005 9.91004 3.79005 8.80004 3.79005Z"
            fill="currentColor" />
          <path
            d="M8.80006 11.4801C5.81006 11.4801 3.02006 9.56013 0.940059 6.06013C0.850059 5.90013 0.850059 5.71013 0.940059 5.55013C3.02006 2.06013 5.81006 0.130127 8.80006 0.130127C11.7901 0.130127 14.5801 2.05013 16.6601 5.55013C16.7501 5.71013 16.7501 5.90013 16.6601 6.06013C14.5801 9.55013 11.7901 11.4801 8.80006 11.4801ZM1.96006 5.80013C3.83006 8.82013 6.25006 10.4701 8.80006 10.4701C11.3501 10.4701 13.7701 8.81013 15.6401 5.80013C13.7701 2.78013 11.3501 1.13013 8.80006 1.13013C6.25006 1.13013 3.83006 2.79013 1.96006 5.80013Z"
            fill="currentColor" />
          <path
            d="M3.57007 11.5401C3.44007 11.5401 3.31007 11.4901 3.22007 11.3901C3.02007 11.1901 3.02007 10.8801 3.22007 10.6801L13.6801 0.220068C13.8701 0.0200684 14.1901 0.0200684 14.3901 0.220068C14.5901 0.420068 14.5901 0.730068 14.3901 0.930068L3.93007 11.3901C3.83007 11.4901 3.70007 11.5401 3.58007 11.5401H3.57007Z"
            fill="currentColor" />
        </svg>
      }
      @case ('close') {
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="100%"
          height="100%"
          viewBox="0 0 16 16"
          fill="none">
          <path
            d="M8 0C3.58947 0 0 3.58947 0 8C0 12.4105 3.58947 16 8 16C12.4105 16 16 12.4105 16 8C16 3.58947 12.4105 0 8 0ZM8 15.1579C4.05263 15.1579 0.842105 11.9474 0.842105 8C0.842105 4.05263 4.05263 0.842105 8 0.842105C11.9474 0.842105 15.1579 4.05263 15.1579 8C15.1579 11.9474 11.9474 15.1579 8 15.1579ZM10.4714 5.52859C10.2109 5.26812 9.78906 5.26812 9.52859 5.52859L8 7.05718L6.47141 5.52859C6.21094 5.26812 5.78906 5.26812 5.52859 5.52859C5.26812 5.78906 5.26812 6.21094 5.52859 6.47141L7.05718 8L5.52859 9.52859C5.26812 9.78906 5.26812 10.2109 5.52859 10.4714C5.65882 10.6017 5.82941 10.6668 6 10.6668C6.17059 10.6668 6.34118 10.6017 6.47141 10.4714L8 8.94282L9.52859 10.4714C9.65882 10.6017 9.82941 10.6668 10 10.6668C10.1706 10.6668 10.3412 10.6017 10.4714 10.4714C10.7319 10.2109 10.7319 9.78906 10.4714 9.52859L8.94282 8L10.4714 6.47141C10.7319 6.21094 10.7319 5.78906 10.4714 5.52859Z"
            fill="currentColor" />
        </svg>
      }
      @case ('search') {
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="100%"
          height="100%"
          viewBox="0 0 14 14"
          fill="none">
          <g clip-path="url(#clip0_138_59028)">
            <path
              d="M7 0C3.14286 0 0 3.14286 0 7C0 10.8571 3.14286 14 7 14C10.8571 14 14 10.8571 14 7C14 3.14286 10.8571 0 7 0ZM7 13.2585C3.54422 13.2585 0.734694 10.449 0.734694 6.9932C0.734694 3.53741 3.54422 0.734694 7 0.734694C10.4558 0.734694 13.2653 3.54422 13.2653 7C13.2653 10.4558 10.4558 13.2653 7 13.2653V13.2585Z"
              fill="currentColor" />
            <path
              d="M10.966 10.3265L8.8776 8.23808C9.42182 7.57821 9.71434 6.74828 9.71434 5.89794C9.71434 3.85032 8.04767 2.18365 6.00005 2.18365C3.95243 2.18365 2.28577 3.85032 2.28577 5.89794C2.28577 7.94556 3.95243 9.61223 6.00005 9.61223C6.85039 9.61223 7.68032 9.31291 8.34019 8.77549L10.4014 10.8367C10.4762 10.9047 10.5647 10.9456 10.6667 10.9456C10.7688 10.9456 10.864 10.9047 10.932 10.8367C11.0681 10.7007 11.0749 10.483 10.9592 10.3333L10.966 10.3265ZM6.00686 8.85712C4.3742 8.85712 3.04767 7.53059 3.04767 5.89794C3.04767 4.26529 4.3742 2.93876 6.00686 2.93876C7.63951 2.93876 8.96604 4.26529 8.96604 5.89794C8.96604 7.53059 7.63951 8.85712 6.00686 8.85712Z"
              fill="currentColor" />
          </g>
          <defs>
            <clipPath id="clip0_138_59028">
              <rect
                width="14"
                height="14"
                fill="white" />
            </clipPath>
          </defs>
        </svg>
      }
      @case ('upload') {
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="100%"
          height="100%"
          viewBox="0 0 16 15"
          fill="currentColor">
          <g clip-path="url(#clip0_272_55999)">
            <path
              d="M5.97997 3.67292L7.38007 2.2108V6.64122C7.38007 7.00234 7.65841 7.29301 8.00422 7.29301C8.35003 7.29301 8.62836 7.00234 8.62836 6.64122V2.2108L10.0285 3.67292C10.2646 3.91955 10.6695 3.91955 10.9056 3.67292C11.1502 3.41749 11.1502 3.01233 10.9056 2.75689L8.4428 0.193771C8.19821 -0.0616606 7.81023 -0.0616606 7.56563 0.193771L5.10279 2.7657C4.98471 2.88901 4.91724 3.04756 4.91724 3.22372C4.91724 3.39988 4.98471 3.55842 5.10279 3.68173C5.34739 3.93716 5.73537 3.93716 5.97997 3.68173V3.67292Z"
              fill="#currentColor" />
            <path
              d="M12.1033 5.99829C11.7575 5.99829 11.4792 6.28895 11.4792 6.65008C11.4792 7.01121 11.7575 7.30187 12.1033 7.30187C13.5709 7.30187 14.7601 8.5438 14.7601 10.0764V10.9308C14.7601 12.4634 13.5709 13.7053 12.1033 13.7053H3.89668C2.4291 13.7053 1.23985 12.4634 1.23985 10.9308V10.0764C1.23985 8.5438 2.4291 7.30187 3.89668 7.30187C4.24249 7.30187 4.52082 7.01121 4.52082 6.65008C4.52082 6.28895 4.24249 5.99829 3.89668 5.99829C1.74591 5.99829 0 7.83035 0 10.0676V10.922C0 13.168 1.75435 14.9912 3.89668 14.9912H12.0949C14.2457 14.9912 15.9916 13.1592 15.9916 10.922V10.0676C15.9916 7.82154 14.2457 5.99829 12.0949 5.99829H12.1033Z"
              fill="#currentColor" />
            <path
              d="M12.1033 11.1421C12.6684 11.1421 13.1323 10.6576 13.1323 10.0675C13.1323 9.47736 12.6684 8.99292 12.1033 8.99292C11.5382 8.99292 11.0743 9.47736 11.0743 10.0675C11.0743 10.6576 11.5382 11.1421 12.1033 11.1421Z"
              fill="#currentColor" />
          </g>
          <defs>
            <clipPath id="clip0_272_55999">
              <rect
                width="16"
                height="15"
                fill="white" />
            </clipPath>
          </defs>
        </svg>
      }
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IconUi {
  name = input<IconName>()
}
